__turbopack_context__.v({
  "attribution": "object-as-archival-label-module-scss-module__QWulha__attribution",
  "content": "object-as-archival-label-module-scss-module__QWulha__content",
  "imageWrapper": "object-as-archival-label-module-scss-module__QWulha__imageWrapper",
  "label": "object-as-archival-label-module-scss-module__QWulha__label",
  "noImageContainer": "object-as-archival-label-module-scss-module__QWulha__noImageContainer",
  "text": "object-as-archival-label-module-scss-module__QWulha__text",
  "textWrapper": "object-as-archival-label-module-scss-module__QWulha__textWrapper",
  "thumbnail": "object-as-archival-label-module-scss-module__QWulha__thumbnail",
  "thumbnails": "object-as-archival-label-module-scss-module__QWulha__thumbnails",
  "title": "object-as-archival-label-module-scss-module__QWulha__title",
});
